type Variant = "primary" | "primary-white" | "formal" | "formal-white";

const FORMAL_SOURCES: Record<Extract<Variant, "formal" | "formal-white">, string> = {
  formal: "assets/logos/taido_formal.svg",
  "formal-white": "assets/logos/taido_formal_white.svg",
};

interface Props {
  variant?: Variant;
  height?: number;
  className?: string;
  /**
   * If true, the logo is treated as a high-priority resource (LCP candidate).
   * Use for the header logo so the browser fetches it ahead of other resources.
   */
  priority?: boolean;
}

export function Logo({ variant = "primary", height = 36, className, priority = false }: Props) {
  const isLight = variant === "primary-white" || variant === "formal-white";

  // The primary brand is live text so it receives the loaded Spectral face.
  // The formal variants remain dedicated assets because their brand lock-up
  // has a distinct, approved composition.
  if (variant === "formal" || variant === "formal-white") {
    const base = import.meta.env.BASE_URL;
    const width = Math.round(height * (160 / 60));
    return (
      <img
        src={`${base}${FORMAL_SOURCES[variant]}`}
        alt="Taidō"
        width={width}
        height={height}
        style={{ height: `${height}px`, width: `${width}px`, display: "block" }}
        className={className}
        {...(priority
          ? { fetchPriority: "high" as const, decoding: "sync" as const, loading: "eager" as const }
          : {})}
      />
    );
  }

  return (
    <span
      aria-label="Taidō"
      className={["taido-logo", isLight ? "taido-logo--light" : "", className]
        .filter(Boolean)
        .join(" ")}
      style={{ fontSize: `${height}px` }}
      {...(priority ? { "data-priority": "true" } : {})}
    >
      <span className="taido-logo__mark">
        Taid<span className="macron">o</span>
      </span>
    </span>
  );
}
